import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient, { isHttpError } from '../httpClient';

export const usePapelUsuario = () => {
  const [papelUsuario, setPapelUsuario] = useState<EnumOption[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPapelUsuario = async () => {
      try {
        const response = await httpClient.get(`/api/users/papelusuario`);

        const options = response.data.map(
          (papelUsuario: { value: number; label: string }) => ({
            value: papelUsuario.value.toString(),
            label: papelUsuario.label,
          }),
        );
        setPapelUsuario(options);
      } catch (error) {
        if (isHttpError(error)) {
          const serverErrorMessage =
            error.response?.data?.message ||
            'Erro ao buscar dados do servidor.';
          setError(serverErrorMessage); // Define o erro no estado
          console.error(
            'Erro de Axios:',
            serverErrorMessage,
            error.response?.data,
          );
        } else {
          const unexpectedErrorMessage =
            'Erro inesperado ao buscar os papéis do usuário.';
          setError(unexpectedErrorMessage); // Define o erro no estado
          console.error(unexpectedErrorMessage, error);
        }
      }
    };

    fetchPapelUsuario();
  }, []);

  return papelUsuario;
};
